import { computed, inject, Injectable, signal } from '@angular/core';
import { ChallengeService } from '../../shared/services/challenge.service';
import { ChallengeResponse } from '../../shared/interfaces/challenge-response.interface';

@Injectable({
  providedIn: 'root'
})
export class ChallengeDataService {
  private challengeService = inject(ChallengeService);

  private _challengesData = signal<ChallengeResponse[]>([]);
  private _challengesCompletedData = signal<ChallengeResponse[]>([]);

  challengesData = computed(() => this._challengesData());
  challengesCompletedData = computed(() => this._challengesCompletedData());
  constructor() {
    this.getProgressChallenge();
    this.getCompletedChallenge();
  }

  
  private getProgressChallenge(): void {
    this.challengeService.getProgressChallenges().subscribe({
      next: (response) => this._challengesData.set(response ?? []),
      error: () => this._challengesData.set([]),
    });
  }

  
  private getCompletedChallenge(): void {
    this.challengeService.getCompletedChallenges().subscribe({
      next: (response) => this._challengesCompletedData.set(response ?? []),
      error: () => this._challengesCompletedData.set([]),
    });
  }

  reloadChallenges() {
    this.getProgressChallenge();
    this.getCompletedChallenge();
  }
}
